export const getUserStatus = (user) => {
  let userStatus = '';

  if (user?.is_active === 0) {
    userStatus = 'Inactive';
  }
  if (user?.is_active === 1 && user?.confirmed === 0) {
    userStatus = 'Unconfirmed';
  }
  if (user?.is_active === 1 && user?.confirmed === 1) {
    userStatus = 'Active';
  }

  return userStatus;
};
